import React from 'react';

import Select from 'react-select';
import 'react-select/dist/react-select.css';

import Details from './Details';

export default class DependentChildren extends React.Component {
    constructor(props) {
        super(props);

        const options = [];
        for (let i = 0; i < 13; ++i) {
            options.push({
                value: i,
                label: i
            });
        }

        this.state = {
            count: 0,
            children: [],
            options
        };
    }

    handleChange = (children) => {
        if (this.props.handleChange) {
            this.props.handleChange(children);
        }
    }

    handleCountChange = (count) => {
        const children = [];
        for (let i = 0; i < count.value; ++i) {
            children.push({
                id: i + 1,
                category: '',
                pcbDeduction: 0
            });
        }

        this.handleChange(children);

        this.setState(Object.assign({},
            this.state,
            {
                count: count.value,
                children
            }
        ));
    }

    handleDetailsChange = (children) => {
        this.handleChange(children);

        this.setState(Object.assign({},
            this.state,
            {
                children
            }
        ));
    }

    render() {
        const { count, children } = this.state;

        return (
            <div>
                <div className='row'>
                    <div className='col-sm-12 col-md-6 col-xl-4'>
                        <div className="pcb-select">
                            <label>
                                NUMBER OF DEPENDENT CHILDREN
                            </label>

                            <Select
                                name="form-field-name"
                                value={count}
                                onChange={this.handleCountChange}
                                options={this.state.options}
                                searchable={false}
                                clearable={false}
                            />
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-sm-12'>
                        <Details children={children} onChange={this.handleDetailsChange} />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Calculator/DependentChildren/index.js